import { useState } from "react";
import { Badge, Collapse, Form, Offcanvas, Table } from "react-bootstrap";
import AiImage from "../../../../img/aiagent.jpg";
import UserProfile from "../../../../img/UserProfile.png";
import { LuSend } from "react-icons/lu";

const FormDataQuery = ({ Show, Hide, Title, onMouseDown, tableRef }) => {
  const [openChatModule, setOpenChatModule] = useState(false);
  const [chatBoxes, setChatBoxes] = useState([
    { id: Date.now(), minimized: false },
  ]);
  const [chatData, setChatData] = useState({});
  const [inputText, setInputText] = useState({});

  const handleSendMessage = (id) => {
    const text = inputText[id];
    if (!text?.trim()) return;

    const newMessage = {
      user: text,
      response: "AI-generated response goes here...",
    };

    setChatData((prev) => ({
      ...prev,
      [id]: [...(prev[id] || []), newMessage],
    }));

    setInputText((prev) => ({ ...prev, [id]: "" }));
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        <Table className="m-0 custom-table">
          <thead className="position-sticky top-0 z-1">
            <tr>
              <th
                onMouseDown={(e) => onMouseDown(e, 0)}
                style={{ width: 45 }}
                className="text-center"
              >
                Sr.
              </th>
              <th>Form Name</th>
              <th>Form Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              className="CP"
              onClick={() => setOpenChatModule(!openChatModule)}
            >
              <td className="text-center">1</td>
              <td>Hemotology</td>
              <td>Active</td>
            </tr>
            <Collapse in={openChatModule === true}>
              <tr>
                <td colSpan={3} className="p-0">
                  <div className="hstack flex-column h-100 w-100 justify-content-between">
                    <div className="p-1 pb-2 CP border-bottom hstack bg-white justify-content-between">
                      <Badge
                        className="text-muted"
                        bg="primary-subtle"
                        style={{ fontSize: 12, borderRadius: 3 }}
                      >
                        #103C5E
                      </Badge>
                      <div style={{ width: 100 }}>
                        <Form.Select
                          className="br3"
                          style={{ fontSize: 11, padding: "1px 0px 1px 10px" }}
                        >
                          <option value="">Active</option>
                          <option value="">Close</option>
                        </Form.Select>
                      </div>
                    </div>

                    <div
                      style={{ height: 300 }}
                      className="w-100 p-2 overflow-auto bg-light"
                    >
                      {(chatData[chatBoxes[0].id] || []).map((chat, index) => (
                        <div
                          key={index}
                          className="d-flex flex-column gap-2 mb-2"
                        >
                          <div className="d-flex gap-2">
                            <img
                              src={UserProfile}
                              alt="User Profile"
                              className="rounded-circle border"
                              style={{ width: 25, height: 25 }}
                            />
                            <div className="bg-white rounded-1 p-2 w-100 lh-sm">
                              <span
                                className="m-0 lh-sm"
                                style={{ fontSize: 12 }}
                              >
                                {chat.user}
                              </span>
                            </div>
                          </div>
                          <div className="d-flex gap-2">
                            <img
                              src={AiImage}
                              alt="AI"
                              style={{ marginTop: 5, height: 25, width: 25 }}
                            />
                            <div className="w-100">
                              <div className="bg-white rounded-1 p-2 w-100 lh-sm">
                                <span
                                  className="m-0 lh-sm"
                                  style={{ fontSize: 12 }}
                                >
                                  {chat.response}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="border-top w-100 bg-white">
                      <div className="hstack">
                        <Form.Control
                          type="text"
                          className="w-100 rounded-0 border-0 border-end"
                          placeholder="Ask Anything"
                          value={inputText[chatBoxes[0].id] || ""}
                          onChange={(e) =>
                            setInputText((prev) => ({
                              ...prev,
                              [chatBoxes[0].id]: e.target.value,
                            }))
                          }
                        />
                        <LuSend
                          style={{ width: 40 }}
                          title="Send"
                          className="CP"
                          onClick={() => handleSendMessage(chatBoxes[0].id)}
                        />
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </Collapse>
          </tbody>
        </Table>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default FormDataQuery;
